module.exports = {
    title: "Business Traveller Response List",
    crud: {
        create: "Create Response",
        edit: "Edit Response",
        view: "View Response",
    },
    table: {
        response: "Response",
        priority: "Priority",
        username: "Response By",
        description: "Description",
        traveller: "Traveller",
        user: "Traveller",
        sender: 'Sender',
    },
    form: {
        priority: "Priority",
        user: "Response By",
        sender: 'Sender',
        traveller: "Traveller",
        response: "Response Message",
        isActive: "Active",
        description: "Description",
    },
    validation: {
        required: {
            response: 'Response Message is required',
            user: 'Sender is required',
        },

    },
}
